import React, { useEffect, useState } from "react";
import Service from "../Service/http";
import Util from "../Service/util";
import { toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { FadeLoader } from "react-spinners";
import TimeAgo from 'react-timeago';
import {MdOutlineRefresh} from 'react-icons/md'
import './TimeLine.css';
import { debounce } from "lodash";
import FollowUpModal from "../Leaderboard/FollowUpModal";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import RemoveIcon from '@mui/icons-material/Remove';

const Users = (props) => {
  const service = new Service();
  const util = new Util();
  let [page, SetPage] = useState(1);
  let [total, SetTotal] = useState(null);
  let [limit, SetLimit] = useState(20);
  let [pages, SetPages] = useState(1);
  let [users, SetUsers] = useState([]);
  let [query, SetQuery] = useState("");
  let [loading, SetLoading] = useState(false);
  let [role, SetRole] = useState('trainer');
  let [batches, setBatches] = useState([]);
  let [allBatches, setAllBatches] = useState([]);
  let [batch, setBatch] = useState("");
  let [id, setId] = useState(null)
  let [batchUpdated, setbatchUpdated] = useState(false)
  let [followup, setfollowup] = useState("");
  let [followupId,SetfollowupId] = useState(null);
  let [followupList, setFollowupList] = useState([]);
  let [current_user, setCurrent_user] = useState("");
  let [edit, Setedit] = useState(false);
  let [ratingPoints,setratingPoints] = useState(0);
  let [ratingString,setratingString] = useState("FollowUp Rating")
  let [collegeOptions, setCollegeOptions] = useState(null);
  let [refresh,setrefresh] = useState(false);
  let [isStudentOrCollege, SetIsStudentOrCollege] = useState(true);
  const [followUpFilter, setFollowUpFilter] = useState(-1)

  useEffect(()=>{
    if (role != "student" && role != "college") SetIsStudentOrCollege(false);
  },[])


  useEffect(()=>{
    service
      .get("api/getColleges")
      .then((json) => {
        setCollegeOptions(json);
      })
      .catch((error) => {
        console.log(error);
      });
  },[refresh])

  const crawlUser=(usid)=>{
    SetLoading(true);
    service
      .put("api/user/clear/lastcrawltime", { user_id: usid})
      .then((json) => {
        SetLoading(false);
        toast.success("User set for crawl");
      })
      .catch((error) => {
        SetLoading(false);
        toast.error("Someting went wrong");
        console.log(error);
      });
  }

  const addCollegeToBatch = (collegeId,userId) =>{
    
    console.log(collegeId)
    SetLoading(true)
    service
      .post("api/addCollegeToUser",{collegeId:collegeId,userId:userId})
      .then((json) => {
        SetLoading(false)
        setrefresh(!refresh)
        toast.success("Added College To College Role")
      })
      .catch((error) => {
        console.log(error);
        SetLoading(false)
        toast.error("Error Occured While Adding Collge To College Role")
      });
  }


  let editComment = () => {
    SetLoading(true);
    Setedit(false);
    setfollowup("");
    setratingString("FollowUp Rating")
    setratingPoints(0)
    service
      .put("api/user/followup", { user_id: id, message: followup, updated_by: current_user, followupId: followupId,UserPoints:ratingPoints})
      .then((json) => {
        service
          .get(`api/user/followup/${id}`)
          .then((json) => {
            if (json.result !== null) {
              setFollowupList(json.result);
            }
          })
          .catch((error) => {
            toast.error("Someting went wrong");
            console.log(error);
          });
        SetLoading(false);
        toast.success("saved");
        setbatchUpdated(!batchUpdated);
      })
      .catch((error) => {
        SetLoading(false);
        toast.error("Someting went wrong");
        console.log(error);
      });
  }
  let editFollowup = (efollowup, _id) => {
    setfollowup(efollowup);
    SetfollowupId(_id);
    Setedit(true);
  }
  let clearData = () => {
    setFollowupList([])
    setratingString("FollowUp Rating")
    setratingPoints(0)
  }
  let getFollowup = (user_id) => {
    SetLoading(true);
    setId(user_id);
    Setedit(false);
    service
      .get(`api/user/followup/${user_id}`)
      .then((json) => {
        if (json.result !== null) {
          // setFollowupObj(json.result);
          setFollowupList(json.result);
          SetLoading(false);
        }
      })
      .catch((error) => {
        toast.error("Someting went wrong");
        console.log(error);
      });
  }
  let handlefollowupchange = (e) => {
    setfollowup(e.target.value);
  };

  const addfollowUpToList = (followup) => {
    SetLoading(true);
    setfollowup("")
    setratingString("FollowUp Rating")
    setratingPoints(0)
    service
      .post("api/user/followup", { user_id: id, message: followup, updated_by: current_user,UserPoints:ratingPoints })
      .then((json) => {

        service
          .get(`api/user/followup/${id}`)
          .then((json) => {
            if (json.result !== null) {
              setFollowupList(json.result);
            }
          })
          .catch((error) => {
            toast.error("Someting went wrong");
            console.log(error);
          });
        SetLoading(false);
        toast.success("saved");
        setbatchUpdated(!batchUpdated);
      })
      .catch((error) => {
        SetLoading(false);
        toast.error("Someting went wrong");
        console.log(error);
      });
  }


  const updateUserBatches = (ubatch, usid, op) => {
    SetLoading(true);
    if (op === "add") {
      setBatches([...batches, ubatch]);
      setBatch("");
    }
    else {
      let fbatches = batches?.filter((batchi) => {
        return ubatch !== batchi;
      });
      setBatches(fbatches);
    }
    service
      .put("api/users/batchupdate", { usid, ubatch, op })
      .then((json) => {
        SetLoading(false);
        toast.success("saved");
        setbatchUpdated(!batchUpdated);
      })
      .catch((error) => {
        SetLoading(false);
        toast.error("Someting went wrong");
        console.log(error);
      });
  };

  const sendBatches = (batchArray, uid) => {
    setBatches(batchArray);
    setId(uid);
  }
  let handleBatchchange = (e) => {
    let batch_name = e.target.value;
    setBatch(batch_name);
  };

  const updateUserCrawler = (user_id, status) => {
    SetLoading(true);
    service
      .put("api/user/crawler/update", { user_id, status })
      .then((json) => {
        SetLoading(false);
        toast.success("saved");
      })
      .catch((error) => {
        SetLoading(false);
        toast.error("Someting went wrong");
        console.log(error);
      });
  };




  const updateDelete = (user_id, status) => {
    SetLoading(true);
    service
      .put("api/user/delete/update", { user_id, status })
      .then((json) => {
        SetLoading(false);
        toast.success("saved");
      })
      .catch((error) => {
        SetLoading(false);
        toast.error("Someting went wrong");
        console.log(error);
      });
  };

  useEffect(()=>{
    service.get("api/batches").then(json => {
      setAllBatches(json.batches)
    })
    .catch((err) =>{
      console.log(err);
    })
  },[])
  
  useEffect(() => {
    SetRole(util.getRole());
    setCurrent_user(util.getName())
    SetLoading(true);
    service
      .get(
        "api/admin/api/users?page=" +
        page +
        "&queryData=" +
        query +
        "&size=" +
        limit +
        "&followUp=" +
        followUpFilter
      )
      .then((json) => {
        SetTotal(json.result.total);
        SetLimit(json.result.limit);
        SetPages(json.result.pages);
        SetUsers(json.result.docs);
        SetLoading(false);
      })
      .catch((error) => {
        console.log(error);
        SetLoading(false);
      });
  }, [page, query, batchUpdated,refresh, followUpFilter]);

  const changeRole = (role, ind, userId) => {

    var answer = window.confirm("Are you sure to save change?");
    if (answer) {
      service
        .put("api/user/role/update", { user_id: userId, role: role })
        .then((json) => {
          toast.success("Saved");
          let obj = [...users];
          obj[ind].role = role;
          SetUsers(obj);
        })
        .catch((error) => {
          toast.error("error while saving");
          console.log(error);
        });
    } else {
      console.log("change not saved");
    }





  };

  const handleChange = (e, v) => {
    SetPage(v);
  };

  
  const BuildCSV = () => {
  if (followupList.length === 0) {
    return;
  }

  const csvHeaders = ['createdAt', 'created_by', 'message', 'updatedAt', 'updated_by', 'userId'];
  let csvContent = csvHeaders.join(',') + '\r\n';

  followupList.forEach((item) => {
    const row = [
      item.createdAt,
      item.created_by,
      item.message,
      item.updatedAt,
      item.updated_by,
      item.userId,
    ];
    csvContent += row.map((cell) => `"${cell}"`).join(',') + '\r\n';
  });

  const csvData = encodeURI(csvContent);
  const fileName = 'followuplist.csv';
  const link = document.createElement('a');
  link.href = 'data:text/csv;charset=utf-8,' + csvData;
  link.target = '_blank';
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const handleDebounce = debounce((value) => {
    SetQuery(value);
    SetPage(1);
  }, 1000);



  return (
    <div>
      <div className="modal fade" id="graphModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Batches of this User</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div className="text-center m-2">
                <b>List Of Batches User is/was Part Of</b>{" "}
              </div>
              <div className="d-flex justify-content-center">
                {batches?.map((batch, ind) => {
                  return (
                    <div key={ind}>
                      <span className="badge bg-primary m-2">
                        {batch}{" "}

                        <button type="button" onClick={() => updateUserBatches(batch, id, "remove")}>
                          X
                        </button>
                        {" "}
                      </span>
                    </div>
                  );
                })}
              </div>





              <div className=" col-lg-6 col-md-12 col-sm-12 mx-auto">
                <div className="input-group ">
                <label
                  className="p-1 input-group-text text-primary ps-2"
                  id="basic-addon1"
                >
                  Batches
                </label>

                <select
                  className="form-select text-primary"
                  name="Batch"
                  onChange={(e) => {
                    setBatch(e.target.value)
                  }}
                >
                  {" "}
                  <option value="select">
                    SELECT BATCHES
                  </option>
                  {allBatches?.map((ele, ind) => {
                    if(batches?.find(element => element == ele)==undefined){
                      return (
                        <option key={ind} value={ele}>
                          {ele}
                        </option>
                      );
                    }
                  })}
                </select>
                <button
                    onClick={() => updateUserBatches(batch, id, "add")}
                    type="button"
                    className="btn btn-primary"
                    disabled={batch=="" || batch=="select"}
                  >
                    Add Batch
                  </button>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>

      <FollowUpModal 
        followupList={followupList} 
        isStudentOrCollege={isStudentOrCollege}
        modalLoaderOn={loading}
        selectedName={"User"}
        setFollowupList={setFollowupList}
        userId={id}
      />

      <div className="m-2">

        <div className="d-flex container-fluid">

          <input
            type="text"
            className="form-control "
            placeholder="Filter with Name & Roll"
            onChange={(e) => handleDebounce(e.target.value)}
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
          />

        </div>


        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{height: '80vh'}}>
          <FadeLoader color="#17A2B8" className="mt-5" />
          </div>
        ) : (

          <div>

            {users.length > 0 ? (
              <>
              <div className="mt-2 text-center overflow-scroll container-fluid">

                <table className="" id="customers">

                  <thead>
                    <tr className="bg-light text-center ">
                      <th className="text-center">SR</th>
                      <th className="text-center">Pic</th>
                      <th className="text-center">Name</th>
                      <th className="text-center">Roll No</th>
                      <th className="text-center">Created By</th>
                      {/* <th>Joined On</th>
                            <th>Updated On</th> */}
                      <th className="text-center">Deleted</th>
                      <th className="text-center">Batches</th>
                      <th className="text-center">Crawler</th>
                      {role === "admin" ? <th className="text-center">Role</th> : null}
                        <th className="text-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            if (followUpFilter === -1) {
                              setFollowUpFilter(1)
                            }
                            else if (followUpFilter === 1) {
                              setFollowUpFilter(0)
                            }
                            else {
                              setFollowUpFilter(-1)
                            }
                          }}
                        >
                          FollowUp
                          {followUpFilter === 1 && <KeyboardArrowUpIcon />}
                          {followUpFilter === -1 && <KeyboardArrowDownIcon />}
                          {followUpFilter === 0 && <RemoveIcon />}
                        </th>
                      <th className="text-center">Pts</th>

                    </tr>
                  </thead>
                  <tbody>

                    {users.map((ele, ind) => {
                      return (
                        <tr key={ind} className="p-0 m-0" style={{"backgroundColor":ele.sincerityScore>0?"#c6ecc6":ele.sincerityScore<0?"#ffe6e6":ele.negativeComment?"#ffdb99":null}}>
                          <td>{limit * (page - 1) + ind + 1}</td>
                          <td >
                            <img src={ele.avatar} width={"35px"} />
                          </td>
                          <td className="p-0 m-0">
                            <div className="p-0 m-0"><a href={"/coding/profile/" + ele._id} target="_blank"> {ele.name}  </a> </div>
                            <span
                              className="text-muted p-0 m-0"
                              style={{ fontSize: "small" }}
                            >
                              {" "}
                              {ele.email}
                            </span>
                          </td>
                          <td className="p-0 m-0">
                            <div className="p-0 m-0">
                              {" "}
                              <span>{ele.roll_number ? ele.roll_number  : "NA"} <a style={{cursor:'pointer'}} onClick={()=> crawlUser(users[ind]._id)} data-toggle="tooltip" data-placement="top" title="Force Crawl This User"><strong><MdOutlineRefresh/></strong></a>{" "}</span>

                            </div>
                            <span
                              className="text-muted p-0 m-0"
                              style={{ fontSize: "small" }}
                            >
                              {ele._id}

                            </span>

                          </td>
                          <td className="p-0 m-0 text-muted" style={{ fontSize: "small" }} ><div className="p-0 m-0 ">
                            {ele?.createdAt ? new Date(ele.createdAt).toLocaleString() : null}
                          </div><span className="p-0 m-0 text-muted"  >{ele.pre_created_by}</span></td>
                          {/* <td> {(ele.creationDate)?new Date(
                                                            ele.creationDate
                                                        ).toLocaleDateString():null}</td> */}
                          {/* <td>{ele.updationDate}</td> */}
                          {/* <td> {(ele.updationDate)?new Date(
                                                            ele.updationDate
                                                        ).toLocaleDateString():null}</td>*/}
                          <td className="text-center align-center">
                            <div className="form-check form-switch text-center">
                              <input
                                className="form-check-input text-center "
                                type="checkbox"
                                checked={ele.is_deleted}
                                onChange={(e) => {
                                  let obj = [...users];
                                  obj[ind].is_deleted =
                                    e.target.checked;
                                  SetUsers(obj);
                                  updateDelete(ele._id, e.target.checked);
                                  // console.log(e.target.checked);
                                }}
                              />
                              <label className="text-muted form-check-label">
                                Delete
                              </label>
                            </div>
                          </td>


                          <td className="text-center aling-center">

                            <div className="d-flex justify-content-center flex-column">
                              {users[ind].batches?.length > 0 ? users[ind].batches?.map((batch, indx) => {
                                return (
                                  <div key={indx}>
                                    <span className="badge bg-primary m-2">
                                      {batch}{" "}

                                      <button type="button" onClick={() => {

                                        updateUserBatches(batch, users[ind]._id, "remove");
                                      }}>
                                        X
                                      </button>
                                      {" "}
                                    </span>
                                  </div>
                                );
                              }) : <p className="text-primary">Not Part Of Any Batch</p>}
                            </div>
                            <a
                              className="text-secondary"
                              data-bs-toggle="modal" data-bs-target="#graphModal"
                              href="#"
                              onClick={() => sendBatches(users[ind].batches, users[ind]._id)}
                            > ... </a>

                          </td>

                          <td className="text-center aling-center">
                            <div className="form-check form-switch text-center">
                              <input
                                className="form-check-input text-center "
                                type="checkbox"
                                checked={ele.is_crawling_approved}
                                onChange={(e) => {
                                  let obj = [...users];
                                  obj[ind].is_crawling_approved =
                                    e.target.checked;
                                  SetUsers(obj);
                                  updateUserCrawler(ele._id, e.target.checked);
                                  // console.log(e.target.checked);
                                }}
                              />
                              <label className="text-muted form-check-label">
                                approve
                              </label>
                            </div>
                          </td>
                          {role === "admin" ? <td>
                            <div className="form-group">
                              <select
                                className="form-select "
                                value={ele.role}
                                name="role"

                                onChange={(e) => {
                                  changeRole(e.target.value, ind, ele._id);
                                }}
                                id="exampleSelect1"
                              >
                                <option value="admin"> admin</option>
                                <option value="trainer"> trainer</option>
                                <option value="mentor"> mentor</option>
                                <option value="college"> college</option>
                                <option value="student"> student</option>
                              </select>
                            </div>
                           
                            {
                              
                              ele.role==="college"&&(
                                
                                <div className="form-group">
                                  
                              <select
                                className="form-select "
                               
                                name="college"

                                onChange={(e) => {
                                  addCollegeToBatch(e.target.value,ele._id)
                                }}
                                id="exampleSelect1"
                              >
                                <option value="null">SELECT COLLEGE</option>
                  {collegeOptions&&collegeOptions?.data?.map((ele_, ind) => {
                    return (
                      <option key={ind} value={ele_._id}>
                        {ele_.college_name}
                      </option>
                    );
                    
                  })}
                  <option value="null">NO COLLEGE</option>
                              </select>
                            </div>
                              )
                            }
                             {ele.role==="college"&&<p>{ele.college_name}</p>}
                          </td> : null}
                          <td className="text-center aling-center">

                            <div className="d-flex justify-content-center">

                              <a
                                className="text-primary"
                                data-bs-toggle="modal" data-bs-target="#followupModal"
                                href="#"
                                onClick={() => {
                                  getFollowup(users[ind]._id)
                                  setratingPoints(0);
                                  setratingString("FollowUp Rating")
                                }}
                              >{
                                  users[ind].last_follow_up ?
                                    <TimeAgo date={new Date(users[ind].last_follow_up)} />
                                    :
                                    <p>never</p>
                                }</a>
                            </div>
                          </td>
                          <td className="text-center aling-center" >
                                {ele.sincerityScore}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <br />
              </div>
              <div className="w-100 d-flex justify-content-center">
                  <Pagination
                    count={pages}
                    color="primary"
                    defaultPage={1}
                    page={page}
                    onChange={handleChange}
                    variant="outlined" 
                    shape="rounded"
                  />
                </div>
            </>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default Users;
